import {
  AUTH_ERROR_CODES,
  AUTH_ERROR_MESSAGES,
  type AuthErrorCode,
} from '../constants/auth.constants'

/**
 * Typed error thrown from the auth service layer. Keeps UI free from string
 * matching — pages branch on `code` and pick a message from
 * AUTH_ERROR_MESSAGES or a custom one.
 */
export class AuthError extends Error {
  readonly code: AuthErrorCode

  constructor(code: AuthErrorCode, message?: string) {
    super(message ?? AUTH_ERROR_MESSAGES[code])
    this.name = 'AuthError'
    this.code = code
  }
}

export const isAuthError = (err: unknown): err is AuthError =>
  err instanceof AuthError

export const toAuthError = (err: unknown): AuthError => {
  if (isAuthError(err)) return err
  return new AuthError(AUTH_ERROR_CODES.UNKNOWN)
}
